import {SvgIcon} from '@mui/material'
import {memo} from 'react'
import Logo from '../../../../resources/logo.svg?react'

export const AppLogo = memo(() => {
  return <SvgIcon component={Logo} inheritViewBox sx={{fontSize: '150%'}}/>
})
